import React from 'react';
import { METRIC_CONFIG } from '../../lib/marketing/metricConfig';
import type { MetricKey } from '../../lib/marketing/metricConfig';

const MultiTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl p-3 text-xs min-w-[160px]">
      <p className="font-semibold text-gray-600 dark:text-gray-300 mb-2">{label}</p>
      {payload.map((p: any, i: number) => (
        <div key={i} className="flex items-center justify-between gap-4 py-0.5">
          <div className="flex items-center gap-1.5">
            <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: p.color }} />
            <span className="text-gray-600 dark:text-gray-300">{p.name}</span>
          </div>
          <span className="font-semibold text-gray-800 dark:text-white">
            {METRIC_CONFIG[p.dataKey as MetricKey]?.formatFn(p.value) ?? p.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default MultiTooltip;
